import React from "react";
import HeaderContainer from "../../components/header/HeaderContainer";
import HeaderTitle from "../../components/header/HeaderTitle";

import QCTbusiness from "../../assets/vendorProduct/QCTbusiness.png";
import QCTcore from "../../assets/vendorProduct/QCTcore.png";
import QCTmission from "../../assets/vendorProduct/QCTmission.png";
import QCTvision from "../../assets/vendorProduct/QCTvision.png";
import QCToverview from "../../assets/vendorProduct/QCToverview.png";
import QCThistory from "../../assets/vendorProduct/QCThistory.png";

import QCTcellular from "../../assets/vendorProduct/QCTcellular.png";
import QCTautomotive from "../../assets/vendorProduct/QCTautomotive.png";
import QCTsmart from "../../assets/vendorProduct/QCTsmart.png";
import QCTwifi from "../../assets/vendorProduct/QCTwifi.png";
import QCTgnss from "../../assets/vendorProduct/QCTgnss.png";
import QCTsatellite from "../../assets/vendorProduct/QCTsatellite.png";
import QCTantenna from "../../assets/vendorProduct/QCTantenna.png";
import QCTservice from "../../assets/vendorProduct/QCTservice.png";

import QCTpartnerProviders from "../../assets/vendorProduct/QCTpartnerProviders.png";
import QCTpartnerTechnology from "../../assets/vendorProduct/QCTpartnerTechnology.png";
import QCTpartnercarriers from "../../assets/vendorProduct/QCTpartnercarriers.png";
import QCTpartnerRegulators from "../../assets/vendorProduct/QCTpartnerRegulators.png";
import QCTpartnerCenter from "../../assets/vendorProduct/QCTpartnerCenter.png";

import SIZE from "../../global/Size";
import COLOR from "../../global/Color";
import SubHeading from "../../components/inner/venderProduct/SubHeading";
import FullImage from "../../components/inner/venderProduct/FullImage";
import styled from "styled-components";
import HeaderContent from "../../components/header/HeaderContent";
import HeaderContentSmall from "../../components/header/HeaderContentSmall";
import ImageTextSmall from "../../components/inner/technologies/ImageTextSmall";
import QCTportfolio from "../../components/inner/venderProduct/QCTportfolio";
import QCTpartnerTwoImage from "../../components/inner/venderProduct/QCTpartnerTwoImage";
import QCTpartnerCenterImage from "../../components/inner/venderProduct/QCTpartnerCenterImage";
import { useLanguage } from "../../context/LanguageContext";
import { siteCopy } from "../../i18n/landingCopy";

const Quectel = () => {
  const { language } = useLanguage();
  const copy = siteCopy[language]?.pages?.vendor?.quectel || siteCopy.en.pages.vendor.quectel;
  const portfolioImageMap = [
    QCTcellular,
    QCTautomotive,
    QCTsmart,
    QCTwifi,
    QCTgnss,
    QCTsatellite,
    QCTantenna,
    QCTservice,
  ];
  const portfolioItems = (copy.portfolioCards || []).map((item, index) => ({
    ...item,
    image: portfolioImageMap[index],
  }));

  return (
    <>
      <HeaderContainer>
        <HeaderTitle>{copy.title}</HeaderTitle>
        <HeaderContent>
          <span style={{ color: COLOR.MAGORELLEBLUE, fontWeight: 700 }}>
            {copy.title}
            <span
              style={{ color: COLOR.BLACK, fontWeight: 300, display: "inline-block" }}
            ></span>
          </span>
          (
          <a
            style={{ textDecoration: "underline", color: "black" }}
            href={copy.website}
            target="_blank"
          >
            {copy.website}
          </a>
          ){copy.headerIntro[0]} 
        </HeaderContent>
        <HeaderContentSmall>{copy.headerIntro[1]}</HeaderContentSmall>
        <HeaderContentSmall>{copy.bodyParagraphs[0]}</HeaderContentSmall>
        <HeaderContentSmall>{copy.bodyParagraphs[1]}</HeaderContentSmall>
        <br />
        <br />
        <SubHeading>{copy.sections.culture}</SubHeading>
        <QCTPhotosContainer>
          <ImageTextSmall Image={QCTmission} />
          <ImageTextSmall Image={QCTvision} />
          <ImageTextSmall Image={QCTcore} />
          <ImageTextSmall Image={QCTbusiness} />
        </QCTPhotosContainer>

        <SubHeading>{copy.sections.companyOverview}</SubHeading>
        <ImageBoxContainer>
          <FullImage Item={QCToverview} />
        </ImageBoxContainer>
        <p
          style={{
            fontSize: SIZE.MEDIUM,
            lineHeight: 1.7,
            paddingLeft: 10,
            marginTop: -10,
          }}
        >
          {copy.overviewParagraph}
        </p>

        <br />
        <br />
        <br />

        <ImageBoxContainer>
          <SubHeading>{copy.sections.history}</SubHeading>
          <FullImage Item={QCThistory} />
        </ImageBoxContainer>

        <br />
        <br />

        <SubHeading>{copy.sections.portfolio}</SubHeading>
        <QCTportfolioContainer>
          {portfolioItems.map((item) => (
            <QCTportfolio
              Image={item.image}
              TitleText={item.title}
              List={item.list}
              herf={item.href}
              moreText={copy.moreText}
            />
          ))}
        </QCTportfolioContainer>
        <p
          style={{
            fontSize: SIZE.XLARGE,
            backgroundColor: "#00FF",
            textAlign: "center",
            padding: "1vh",
            fontWeight: 700,
            color: "#FFF",
          }}
        >
          {copy.portfolioFooter}
        </p>

        <br />
        <br />
        
        <SubHeading>{copy.sections.trusted}</SubHeading>
        <HeaderContentSmall>{copy.trustedDescription}</HeaderContentSmall>
        <QCTpartnerContainer>
          <QCTpartnerTwoImage Image01={QCTpartnerProviders} Image02={QCTpartnerTechnology} />
          <QCTpartnerCenterImage Image={QCTpartnerCenter} />
          <QCTpartnerTwoImage Image01={QCTpartnercarriers} Image02={QCTpartnerRegulators} />
        </QCTpartnerContainer>
      </HeaderContainer>
    </>
  );
};

const ImageBoxContainer = styled.div`
  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 1300px) {
    display: none;
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    display: none;
  }
`;

const QCTPhotosContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  padding-bottom: 40px;
  gap: 20px;
  display: grid;
  grid-template-columns: repeat(4, 1fr);

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const QCTportfolioContainer = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

const QCTpartnerContainer = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  justify-content: center;
  align-items: center;

  /* 450px 이상 800px 미만 */
  @media (min-width: 450px) and (max-width: 799px) {
    grid-template-columns: repeat(2, 1fr);
  }

  /* 450px 미만 */
  @media (max-width: 449px) {
    grid-template-columns: repeat(1, 1fr);
  }
`;

export default Quectel;
